/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */

import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import { FETCH_PERSON_REGISTER_RESET_REASONS_REQUEST, success, failure } from './action';

const fetchPersonRegisterResetReasons = (action$, state$, { AjaxRequest }) =>
  action$
    .ofType(FETCH_PERSON_REGISTER_RESET_REASONS_REQUEST)
    .map(({ payload }) => payload)
    .mergeMap(() =>
      AjaxRequest.open(
        'get',
        '/admin/personcustom/resetreasons',
      )('tudo')
        .flatMap(({ response }) => Observable.of(success(response.resource)))
        .catch((err) => Observable.of(failure(err))),
    );

export default combineEpics(fetchPersonRegisterResetReasons);
